import { render, staticRenderFns } from "./admissionPrint.vue?vue&type=template&id=60c75c94"
import script from "./admissionPrint.vue?vue&type=script&lang=js"
export * from "./admissionPrint.vue?vue&type=script&lang=js"
import style0 from "./admissionPrint.vue?vue&type=style&index=0&id=60c75c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports